import { useState } from 'react';
import checkCookieIssuer from '../data/checkCookieIssuer';
import { fetchPasskeys } from '../data/passkeys';
import { useTwoFactorReAuth } from './useTwoFactorReAuth';
export const useReAuth = () => {
  const [hasPasskeys, setHasPasskeys] = useState(false);
  const {
    hasSecondaryMethod,
    obfuscatedInfo,
    authMethod,
    initializeTwoFactorReAuth
  } = useTwoFactorReAuth();
  const arePasskeysSupported = async () => {
    if (window.PublicKeyCredential && typeof window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable === 'function') {
      try {
        const isAvailable = await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
        return isAvailable;
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  };
  function initializeReAuth({
    onSuccess,
    openModal,
    skipVerificationIfNotSet,
    email
  }) {
    checkCookieIssuer().then(result => {
      const cookieValid = JSON.parse(result);
      if (cookieValid) {
        onSuccess();
      } else {
        throw new Error();
      }
    }).catch(() => {
      if (!email) {
        throw new Error();
      }
      return arePasskeysSupported();
    }).then(isSupported => {
      if (!isSupported) {
        throw new Error();
      }
      return fetchPasskeys();
    }).then(passkeys => {
      if (passkeys.length > 0) {
        setHasPasskeys(true);
        openModal();
      } else {
        throw new Error();
      }
    }).catch(() => {
      initializeTwoFactorReAuth({
        onSuccess,
        openModal,
        skipVerificationIfNotSet
      });
    });
  }
  return {
    hasPasskeys,
    initializeReAuth,
    hasSecondaryMethod,
    obfuscatedInfo,
    authMethod
  };
};